<template lang="pug">
    div(v-if="groupedResults.length > 0")
        h3(v-if="resourceResult.resourceType") {{ $i18n.t(`resourceType.${resourceResult.resourceType}`) }}

        Row(
            v-for="group in groupedResults"
            :key="group.groupName"
        )
            List.launcher-list
                //「appProfileName」+ view all
                template(slot="header")
                    .list-header
                            span.label {{ group.resources[0].appProfileName}}
                            LinkExtend(:routeParams="setFuzzyResourceGroupName(group.fuzzyResource)") {{ viewAllText(group.total) }}
    
                // 每一列 domain + tag + Manage
                ListItem.launcher-list-item.custom-list-item(
                    v-for="item in group.resources"
                    :key="item._id"
                )
                    .list-item-content.custom-list-header
                        .left
                            span.domain-name {{ item._itemName }}
                            span.tags(v-if="item.tags && item.tags.length")
                                Tag(v-for="tag in item.tags" :key="tag") {{ tag }}
                        .right
                            Tag(style="margin-right: 8px") {{ item.groupName }}
                            LinkExtend(:routeParams="item._routeParams") Manage
                            
</template>    

<script>
import LinkExtend from "@/components/LinkExtend.vue";

export default {
    name: "DomainsWithAppProfileGroupView",
    components: {
        LinkExtend,
    },
    props: {
        resourceResult: {
            type: Object,
            required: true,
        },
    },
    computed: {
        groupedResults() {
            return this.resourceResult.groupedResources || [];
        },
    },

    methods: {
        viewAllText(total) {
            if (this.$store.state.queryGroupName == 'all') {
                return `view all ${total} results`;
            }
            return `view all ${total} results at `;
        },
        setFuzzyResourceGroupName(fuzzyResource) {
            return {
                name: fuzzyResource.name, // ex: "ProfileDomain"
                params: { ...fuzzyResource.params }, // ex: { appProfileName: "xxx" }
                query: { ...fuzzyResource.query }, // ex: { groupName, servername }
            };
        },
    },
};
</script>

<style scoped>
/* Placeholder 樣式 */
.search-box >>> ::-webkit-input-placeholder,
.search-box >>> ::-moz-placeholder,
.search-box >>> :-moz-placeholder,
.search-box >>> :-ms-input-placeholder {
    font-style: italic;
    color: rgb(165, 165, 165) !important;
}

/* 輸入框底色與文字顏色 */
.search-box >>> .ivu-input.ivu-input-default {
    background: rgba(45, 45, 45, 0.8);
    color: #ffffff !important;
}

/* 自訂 header 和 item 間距（非 ivu class） */
.custom-list-header,
.custom-list-item {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

/* List 結構樣式 */
.launcher-list {
    width: 100%;
}

/* Header 樣式 */
.list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

/* appProfileName 的 label */
.list-header .label {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 60%;
}

/* List item 外層內容排版 */
.launcher-list-item .list-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-left: 4rem; /* 左邊內縮*/
}

/* 左邊內容（domain + tags） */
.list-item-content .left {
    display: flex;
    align-items: center;
}

.list-item-content .domain-name {
    font-size: 14px;
    margin-right: 8px;
}

.list-item-content .tags .ivu-tag {
    margin-left: 6px;
}

/* 右邊內容（groupName tag + Manage link） */
.list-item-content .right {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DomainsWithAppProfileGroupView.vue